<div class="contains-button">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>

  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <p>{{'dinh_dang_tieu_de' | translate}}</p>
      <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
      [staticdata]="staticdata" [textContentClass]="class['choose-property__title']" [textWrapperClass]="class['choose-property__title']"
      (changeTextAlignConfig)="changeWidthHeight({width: width})">
      </app-text-format-config>
      <!-- Khoảng cách chữ -->
      <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
        [classLetterSpacing]="class['choose-property__title']" (updateClass)="updateClass()">
      </app-letter-spacing-config>
      <!-- Khoảng cách dòng -->
      <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
        [classLineHeight]="class['choose-property__title']" (updateClass)="updateClass()">
      </app-line-height-config>

      <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
      [classPadding]="class['choose-property']" [paddingConfigs]="[
        { type: 'top' },
        { type: 'bottom' },
        { type: 'left' },
        { type: 'right' }
      ]">
    </app-padding-config>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" >
        <!-- Cấu hình thông số cơ bản của button-->
        <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1"
          (nzOpenChange)="openHandler('menu1')">
          <div class="button-size">
            <!-- Lựa chọn hiển thị cho các thiết bị -->
            <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
            </app-hide-show-config>
          </div>
        </li>
        <!-- Cấu hình xoay-->
        <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu10"
          (nzOpenChange)="openHandler('menu10')">
          <app-rotate-config [classRotate]="class['choose-property']" [config]="config" [device]="device"
            [objectChoosing]="objectChoosing"></app-rotate-config>
        </li>
        <!-- Cấu hình format font name của button -->
        <li nz-submenu nzTitle="{{'dinh_dang_tieu_de' | translate}}" [(nzOpen)]="openMap.menu3"
          (nzOpenChange)="openHandler('menu3')">
          <div class="container-font">
            <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
              [staticdata]="staticdata" [textContentClass]="class['choose-property__title']" [textWrapperClass]="class['choose-property__title']"
              (changeTextAlignConfig)="changeWidthHeight({width: width})">
            </app-text-format-config>
            <!-- Khoảng cách chữ -->
            <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classLetterSpacing]="class['choose-property__title']" (updateClass)="updateClass()">
            </app-letter-spacing-config>
            <!-- Khoảng cách dòng -->
            <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classLineHeight]="class['choose-property__title']" (updateClass)="updateClass()">
            </app-line-height-config>

            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['choose-property']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
          </app-padding-config>
          </div>
        </li>
        <!-- Cấu hình format font name của phần tử -->
        <li nz-submenu nzTitle="{{'dinh_dang_phan_tu' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
          <div class="container-font">
            <nz-select class="mb-2" [(ngModel)]="staticdata.choose_mode" nzPlaceHolder="{{'chon_kieu_hien_thi' | translate}}"
            (ngModelChange)="updateStaticData()">
              <nz-option nzValue="checkbox" nzLabel="{{'hien_thi_bang_checkbox' | translate}}"></nz-option>
              <nz-option nzValue="radio" nzLabel="{{'hien_thi_bang_radio' | translate}}"></nz-option>
            </nz-select>
            <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
              [staticdata]="staticdata" [textContentClass]="class['choose-property__item-label']" [textWrapperClass]="class['choose-property__item-label']"
              (changeTextAlignConfig)="changeWidthHeight({width: width})">
            </app-text-format-config>
            <!-- Khoảng cách chữ -->
            <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classLetterSpacing]="class['choose-property__item-label']" (updateClass)="updateClass()">
            </app-letter-spacing-config>
            <!-- Khoảng cách dòng -->
            <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classLineHeight]="class['choose-property__item-label']" (updateClass)="updateClass()">
            </app-line-height-config>
            <div class="color-pick">
              <span class="title w-50">{{'mau_nut_chon' | translate}}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['choose-property__item-input']['accent-color']"
                [style.background]="class['choose-property__item-input']['accent-color']" (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
            </div>
            
            <div class="item-border-radius-top-left">
              <div class="slide-bar">
                <p class="m-0 title-border">{{'kich_thuoc_nut_chon' | translate}}</p>
                <nz-input-number class="input-number" [nzMin]="0"  [nzMax]="2"  [nzStep]=".1"
                  [ngModel]="class['choose-property__item-input']['zoom'] | vhnumber" 
                  (ngModelChange)="class['choose-property__item-input']['zoom'] = $event"
                  (nzBlur)="updateClass()" ></nz-input-number>
              </div>
              <div>
                <nz-slider [ngModel]="class['choose-property__item-input']['zoom'] | vhnumber" [nzMin]="0"
                  [nzStep]=".1"
                  [nzMax]="2" 
                  (ngModelChange)="class['choose-property__item-input']['zoom'] = $event"
                  (nzOnAfterChange)="updateClass()"></nz-slider>
              </div>
            </div>
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['choose-property__item']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
            </app-padding-config>
          </div>
        
        </li>
        <!-- Cấu hình màu nền của button -->
        <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu5"
          (nzOpenChange)="openHandler('menu5')">
          <div class="color-pick">
            <span class="title w-50">{{'mau_nen' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['choose-property']['background-color']"
              [style.background]="class['choose-property']['background-color']" (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
          </div>


        </li>
        <!-- Cấu hình hình dạng viền -->
        <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6"
          (nzOpenChange)="openHandler('menu6')">
          <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
            [borderClass]="class['choose-property']" [id_object]="objectChoosing._id">
          </app-borders-config>

          <!-- Nút mở rộng -->
          <div class="item-border my-3" style="float: right">
            <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>
        </li>
      </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    
  </div>
</div>